<template>
  <div class="sc__systems-landing">
    <TheIntroHero />
    <div class="sc__systems-landing__content container">
      <TheSystemTopics />
      <div>
        <SearchKeyword
          :keyword-label="translations.filters.keywordLabel"
          :selected-keyword="getInitialKeywordSearch"
          :placeholder="translations.filters.keywordSearchText"
          @on-search-keyword-change="onSearchKeywordChange"
        />
      </div>
      <div v-if="hasResults(contentResults)">
        <ScContentTextResults
          :results="contentResults.contentDetails"
          :heading="translations.landingPage.topSolutionsHeading"
          @on-result-selected="onResultSelected"
        >
          <template #pagination>
            <ScPagination
              :ga-event-string="`${systemConfig.mode} - Search,Back Link,Back to Previous`"
              :back-link-text="translations.commonSettings.navigation.back"
              :show-more-link-text="translations.commonSettings.navigation.showMore"
              :showing-text="translations.commonSettings.navigation.showing"
              :of-text="translations.commonSettings.navigation.of"
              :total-count="contentResults.contentCount"
              :current-count="contentResults.contentDetails.length"
              @show-more="onContentShowMore"
            />
          </template>
        </ScContentTextResults>
      </div>
    </div>
    <div class="sc__systems-landing__quick-links">
      <ScQuickLinks
        :heading="quickLinksData.heading"
        :accessible-nav-label="quickLinksData.accessibleNavLabel"
        :image="quickLinksData.image"
        :image-set="quickLinksData.imageSet"
        :links="quickLinksData.links"
        :lazy-load="quickLinksData.lazyLoad"
      />
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss">
  @import './style.scss';
</style>
